export function splitSymbolPair(symbolName) {
    if (!symbolName) return { base: 'COIN', quote: 'CURRENCY' };
    const match = symbolName.match(/^(.*?)(USDT|BUSD|USDC|BTC|ETH|BNB|TRY|EUR|GBP|AUD)$/);
    if (!match) return { base: symbolName, quote: 'CURRENCY' };
    return { base: match[1], quote: match[2] };
}

export function parseQuantityValue(quantity, multiplier) {
    if (quantity === null || quantity === undefined || quantity === '') {
        return { unit: 'base', amount: '' };
    }

    const qty = String(quantity).trim();

    if (qty === 'QUOTE_QTY') {
        const parsed = parseFloat(multiplier);
        return {
            unit: 'quote',
            amount: Number.isFinite(parsed) ? String(parsed) : '',
        };
    }

    if (/^[0-9]/.test(qty)) {
        return { unit: 'base', amount: qty };
    }

    return { unit: 'base', amount: '' };
}

export function serializeQuantityValue(unit, amount) {
    if (unit === 'quote') {
        const parsed = parseFloat(String(amount).replace(',', '.'));
        return {
            quantity: 'QUOTE_QTY',
            quantityMultiplier: Number.isFinite(parsed) ? parsed : 0,
        };
    }

    return {
        quantity: amount || '0',
        quantityMultiplier: 1,
    };
}